import { Button, Icon16Checkmark, Typography } from "@cur8/maneki";
import { CheckInParams } from "lib/types/checkInParameters";
import { usePatientQuery } from "hooks/queries/usePatientQuery";
import { paths } from "render/routes/paths";
import { InformationLayout } from "render/ui/layout/InformationLayout";
import { PageFrameContent } from "render/ui/layout/PageFrameContent";
import { ActionsFooter } from "render/ui/layout/ActionsFooter";
import styles from "./styles.module.sass";

type ManualCheckInConfirmedViewProps = {
  goTo(url: string): void;
} & CheckInParams;

export function ManualCheckInConfirmedView({
  goTo,
  patientId,
}: ManualCheckInConfirmedViewProps) {
  const { data: patient } = usePatientQuery({ patientId });

  const firstName =
    patient?.name?.firstName ?? patient?.name?.displayName ?? "Member";

  return (
    <PageFrameContent>
      <InformationLayout
        content={
          <section className={styles.layout}>
            <div className={styles.icon}>
              <Icon16Checkmark />
            </div>
            <Typography variant="display-s">Checked in</Typography>
            <Typography variant="body-m" color="subtle">
              {firstName} has been checked in successfully.
            </Typography>
          </section>
        }
        buttons={
          <ActionsFooter
            right={
              <Button onPress={() => goTo(paths.root.url({}))} fillContainer>
                Done
              </Button>
            }
          />
        }
      />
    </PageFrameContent>
  );
}
